"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Carousel_1 = __importDefault(require("@/components/Carousel"));
const Button_1 = __importDefault(require("@/components/Button"));
const SystemCard_1 = __importDefault(require("../SystemCard"));
const style_1 = require("./style");
function SitesListRowView({ siteName, systems, onAddsSystem }) {
    return (react_1.default.createElement(style_1.RowWrapper, null,
        react_1.default.createElement(style_1.TitleWrapper, null,
            react_1.default.createElement(Typography_1.default, { variant: "h3" }, siteName),
            react_1.default.createElement(Button_1.default, { onClick: onAddsSystem, label: "Add System" })),
        react_1.default.createElement(Carousel_1.default, { howMuchToShow: systems.length > 4 ? 4 : systems.length }, systems.map((system, i) => {
            return react_1.default.createElement(SystemCard_1.default, { key: i, system: system });
        }))));
}
exports.default = SitesListRowView;
